import React, { FC } from 'react'
import { useQuery } from '@at/sauron-platform-graphql'
import { dealerInfoQuery } from './query/dealer-info.query'
import styled from 'styled-components'
import { TypeInsignia } from '@at/design-system-foundation'
import { DealerInfoQuery_Query, DealerInfoQueryVariables } from './query/__generated__/dealer-info.query'

const StyledRetailerTitle = styled(TypeInsignia)`
    display: flex;
    font-size: 20px;
    align-items: center;
    color: ${({ theme }) => theme.color.text.title};
    text-align: left;
    font-variation-settings: 'wght' 500;
`

export const RetailerTitle: FC<{ retailerId: string }> = (props) => {
    const { retailerId } = props
    const { data } = useQuery<DealerInfoQuery_Query, DealerInfoQueryVariables>(dealerInfoQuery, {
        variables: {
            dealerId: retailerId,
        },
        skip: !retailerId,
    })

    if (data) {
        return <StyledRetailerTitle as="h2">Stock from {data.search.dealer.name}</StyledRetailerTitle>
    } else {
        return null
    }
}
